import Splide from '@splidejs/splide';
import '@splidejs/splide/css';

const pageLpWatch = (): void => {
  /**
   * toggle faq
   */
  const faqItems: NodeListOf<HTMLElement> = document.querySelectorAll('.p-faq-item');
  faqItems.forEach((faqItem: HTMLElement) => {
    const toggleButton: HTMLElement | null = faqItem.querySelector('.p-faq-item__toggle');
    toggleButton?.addEventListener('click', () => {
      faqItem.classList.toggle('is-hidden');
    });
  });

  /**
   * about usのスライダー
   */
  const aboutUsSlider: HTMLElement | null = document.querySelector('.p-about__image');
  if (aboutUsSlider) {
    new Splide(aboutUsSlider, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      gap: 0,
      pagination: false,
      arrows: false,
      pauseOnHover: false,
      // auto play 5秒
      autoplay: true,
      interval: 5000,
    }).mount();
  }

  // /**
  //  * brandのスライダー
  //  */
  // const brandSlider: HTMLElement | null = document.querySelector('.p-brand-slider');
  // if (brandSlider) {
  //   new Splide(brandSlider, {
  //     type: 'loop',
  //     perPage: 3,
  //     perMove: 1,
  //     gap: '3.1rem',
  //     pagination: false,
  //     arrows: true,
  //     pauseOnHover: false,
  //     autoScroll: {
  //       rewind: true,
  //       pauseOnHover: false,
  //       pauseOnFocus: false,
  //       speed: 0.5,
  //     },
  //     breakpoints: {
  //       767: {
  //         perPage: 1,
  //       },
  //     },
  //   }).mount();
  // }

  /**
   * お客様の声のスライダー
   */
  const voiceSlider: HTMLElement | null = document.querySelector('.p-customer-slider');
  if (voiceSlider) {
    new Splide(voiceSlider, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      gap: '3.3rem',
      pagination: true,
      arrows: true,
      pauseOnHover: false,
      autoScroll: {
        rewind: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        speed: 0.5,
      },
      breakpoints: {
        767: {
          gap: '1.4rem',
        },
      },
    }).mount();
  }

  /**
   * サロンご案内のスライダー
   */
  const shopSliders: NodeListOf<HTMLEmbedElement> | [] = document.querySelectorAll('.p-shop-list') || [];
  if (shopSliders.length) {
    shopSliders.forEach((shopSlider: HTMLElement) => {
      new Splide(shopSlider, {
        type: 'slide',
        perPage: 1,
        perMove: 1,
        gap: '2rem',
        pagination: true,
        arrows: true,
        pauseOnHover: false,
        autoScroll: {
          rewind: true,
          pauseOnHover: false,
          pauseOnFocus: false,
          speed: 0.5,
        },
        breakpoints: {
          767: {
            type: 'loop',
          },
        },
      }).mount();
    });
  }

  /**
   * ブランドのmoreボタン
   */
  const brandMoreButton: HTMLElement | null = document.querySelector('.p-brand-all__link');
  const brandList: HTMLElement | null = document.querySelector('.p-brand-all__list');
  if (brandMoreButton && brandList) {
    brandMoreButton.addEventListener('click', () => {
      brandList.classList.toggle('is-open');
    });
  }
};

export default pageLpWatch;
